const baseUrl = "http://4d-tjw.oss-cn-shenzhen.aliyuncs.com/syms/images/";

let raw =  [
    {
      image: baseUrl + "list/01zmsj.png",
      url: "msmk",
      text: "正门视角",
      type: "overlook",
      tag:'etags_msczm'
    },
    {
      image: baseUrl + "list/02sygcsj.png",
      url: "dhy",
      tag:'etags_sygc',
      text: "水悦广场视角",
      type: "overlook"
    },
    {
      image: baseUrl + "list/03pqgcsj.png",
      url: "hbgy",
      text: "喷泉广场视角",
      tag:'etags_lhl',
      type: "overlook"
    },
    {
      image: baseUrl + "list/04yjqsj.png",
      url: "yjq",
      text: "云戒桥视角",
      tag:'etags_yjqout',
      type: "overlook"
    },
    {
      image: baseUrl + "list/05jqqjsj.png",
      url: "zjjd",
      text: "景区全景视角",
      tag:'etags_tfzjjd',
      type: "overlook"
    },
    {
      image: baseUrl + "list/06zxgcsj.png",
      url: "zxgc",
      text: "中心广场视角",
      tag:'etags_zxgc',
      type: "overlook"
    },

    {
      image: baseUrl + "list/01yjgc.png",
      url: "yjgc",
      text: "云戒广场",
      innerTag:'etags_arrow14',
      tag:'etags_yjgc',
      type: "inner"
    },
    {
      image: baseUrl + "list/02xygc.png",
      url: "xygc",
      text: "星悦广场",
      innerTag:'etags_arrow12',
      tag:'etags_xygc',
      type: "inner"
    },
    {
      image: baseUrl + "list/03yygc.png",
      url: "yygc",
      text: "演艺广场",
      innerTag:'etags_arrow13',
      tag:'etags_yygc',
      type: "inner"
    },

    {
      image: baseUrl + "list/04sygc.png",
      url: "tyly",
      text: "水悦广场",
      innerTag:'etags_arrow11',
      tag:'etags_sygcin',
      type: "inner"
    },

    {
      image: baseUrl + "list/05sypq.png",
      url: "sypc",
      text: "水悦喷泉",
      innerTag:'etags_arrow10',
      tag:'etags_sypq',
      type: "inner"
    },

    {
      image: baseUrl + "list/06yjq.png",
      url: "yjq",
      text: "云戒桥",
      innerTag:'etags_arrow15',
      tag:'etags_yjq_qj',
      type: "inner"
    },

    {
      image: baseUrl + "list/07msgcpq.png",
      url: "zmpc",
      text: "中心广场喷泉",
      innerTag:'etags_arrow07',
      tag:'etags_pq',
      type: "inner"
    },
    {
      image: baseUrl + "list/08Aq1.png",
      url: "A1",
      text: "A区1号口",
      tag:'etags_aq1',
      innerTag:'etags_arrow08',
      type: "inner"
    },
    {
      image: baseUrl + "list/09A1.png",
      url: "A1F01",
      text: "A区一楼",
      innerTag:'etags_arrow01',
      type: "inner"
    },
    {
      image: baseUrl + "list/10A2.png",
      url: "A2F04",
      text: "A区二楼",
      innerTag:'etags_arrow02',
      type: "inner"
    },
    {
      image: baseUrl + "list/11A3.png",
      url: "A3F12",
      innerTag:'etags_arrow03',
      text: "A区三楼",
      type: "inner"
    },

    {
      image: baseUrl + "list/12B3.png",
      url: "B3F08",
      text: "B区三楼",
      innerTag:'etags_arrow06',
      type: "inner"
    },
    {
      image: baseUrl + "list/13B2.png",
      url: "B2F02",
      text: "B区二楼",
      innerTag:'etags_arrow05',
      type: "inner"
    },
    {
      image: baseUrl + "list/14B1.png",
      url: "B1F01",
      text: "B区一楼",
      innerTag:'etags_arrow04',
      type: "inner"
    },
    {
      image: baseUrl + "list/15Bq1.png",
      url: "B1",
      text: "B区1号口",
      tag:'etags_bq1',
      innerTag:'etags_arrow09',
      type: "inner"
    },
    {
      image: baseUrl + "list/pixlist_06@2x.png",
      url: "https://www.4dkankan.com/spc.html?m=2mNTCah7L&lang=zh",
      text: "三层连廊",
      tag:'etags_scll',
      type: "newTab"
    },
    {
      image: baseUrl + "list/pixlist_06@2x.png",
      url: "https://www.4dkankan.com/spc.html?m=NhIolbHTu&lang=zh",
      text: "云戒桥",
      tag:'etags_yjq',
      type: "newTab"
    }
]

let data = []
let inner = []
let newTab = []

raw.forEach(item=>{
  if (item.type === 'overlook') {
    data.push(item)
  }
  if (item.type === 'inner') {
    inner.push(item)
  }
  if (item.type === 'newTab') {
    newTab.push(item)
  }
})



export {raw, data,inner,newTab };
